module.exports = __webpack_public_path__ + "static/media/influencer-empty.61d2f8fd.svg";